export enum EResearchState {
  ERS_NotResearching,
  ERS_Researching,
}

export const EResearchStateDisplayName = {
  [EResearchState.ERS_NotResearching]: 'Not Researching',
  [EResearchState.ERS_Researching]: 'Researching',
};
